import Vuex from 'vuex'
import Vue from 'vue'
import http from '@/http'

Vue.use(Vuex)


const state = {
    token: null,
    usuario: {},
    perfil: '',
    nome: '',
    username:'',

    dlgLoading: false,

    processoSelecionado: {},
    listaProcessos: [],
}

const mutations= {

    DEFINIR_USUARIO_LOGADO ( state, { token, usuario, perfil, nome, username}){
        console.log("definindo usuário" + username);
        state.token = token;
        state.usuario = usuario;
        state.perfil = perfil;
        state.nome = nome;
        state.username = username;
        localStorage.setItem('token', token);
        localStorage.setItem('usuario', usuario);
        localStorage.setItem('perfil', perfil);
        localStorage.setItem('nome', nome);
        localStorage.setItem('username', username);
    },

    DESLOGAR_USUARIO ( state){
        state.token = null
        state.usuario = null
        state.perfil = null
        state.nome = null

        mutations.clearLocalStorage();
    },

    clearLocalStorage() {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('perfil');
        localStorage.removeItem('nome');
        localStorage.removeItem('username');
        localStorage.removeItem('listaProcessos');
    },

    setProcessoSelecionado(state, processoSelecionado) {
        state.processoSelecionado = JSON.parse(JSON.stringify(processoSelecionado));
        localStorage.setItem('processoSelecionado', JSON.stringify(processoSelecionado));
    },
    setListaProcessos(state, listaProcessos) {
        state.listaProcessos = JSON.parse(JSON.stringify(listaProcessos));
        localStorage.setItem('listaProcessos', JSON.stringify(listaProcessos));
    },
    setDlgLoading(state, payload) {
        state.dlgLoading = payload
    },

  }

const actions = {
  
    efetuarLogin({ commit }, usuario) {
     return new Promise((resolve, reject) => {
           console.table(usuario)
           http.post('login', usuario)
          .then(response => {
              commit('DEFINIR_USUARIO_LOGADO', {
              token:  response.headers.authorization,
              usuario: response.data.id,
              perfil: response.data.perfil,
              nome: response.data.nome
            });
            state.processoSelecionado = JSON.parse(localStorage.getItem('processoSelecionado'));
            resolve(response.data);
          })
          .catch(err => {
            console.table(err)
              reject(err)
          })
      })
  },

  efetuarLoginLdap({ commit }, usuario) {
    return new Promise((resolve, reject) => {
          http.post('auth/authenticate', usuario)
         .then(response => {
             commit('DEFINIR_USUARIO_LOGADO', {
             token:  response.headers.authorization,
             usuario: response.data.id,
             perfil: response.data.perfil,
             nome: response.data.nome,
             username: response.data.userName
           })
           resolve(response.data);
         })
         .catch(err => {
             reject(err)
         })
     })
 }

}

export default new Vuex.Store({
    state,
    mutations,
    actions
})
